import { render, staticRenderFns } from "./AcceptanceTerms.vue?vue&type=template&id=6e91e95e"
import script from "./AcceptanceTerms.vue?vue&type=script&lang=js"
export * from "./AcceptanceTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports